<template>
  <el-dialog custom-class="medium-dialog" title="扫码出库" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
          <td style="text-align: center;width: 40px">序号</td>
          <td style="text-align: center;">名称</td>
          <td style="text-align: center;width:140px;" >规格</td>
          <td style="text-align: center;width:220px;">唯一码</td>
          <td style="text-align: center;width:120px;">批次号</td>
          <td style="text-align: center;width:120px;">有效期</td>
        </tr>
        <tr v-for="(item,i) in scancodes">
          <td>{{i+1}}</td>
          <td>{{item.seedname}}</td>
          <td>{{getPackagesize(item.packagesize)}}</td>
          <td>{{item.storegoodsbarcode}}</td>
          <td style="text-align: center;">{{formatDate(item.starttime)}}</td>
          <td style="text-align: center;">{{formatDate(item.endtime)}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="hideDialog(false)">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="canedit">确定出库</el-button>
      <el-input style="width: 130px" ref="inputScan" size="small" v-model="storegoodsbarcode" v-if="canedit" placeholder="扫唯一码"  onfocus="this.select()" @keyup.enter.native="getZyanjingQRCode()"></el-input>
    </div>
  </el-dialog>
</template>

<script>
  import {listBar,batchSave,printBar,getQRCode,updateouttime as updateQRouttime,checkBars} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: "QRCodeScan",
    data() {
      return {
        canedit: false,
        loading:false,
        scancodes: [],
        storegoodsbarcode: '',
        dialogFormVisible: false,
        controlData:{},
        needsaveQRCode:'',
        plus:true
      }
    },
    methods: {
      show(controlData, canedit) {
        this.loading = true;
        this.controlData = controlData; // erpserial,cangkucode,seedcode
        this.scancodes=[];
        this.needsaveQRCode='';
        this.canedit = canedit;
        this.plus=true;
        this.dialogFormVisible = true;
        if (controlData.erpserial) {//取临时存储的值
          listBar({outordernum: controlData.erpserial}).then(response => {
            this.scancodes = response.data.obj.rows
            this.loading = false;
            if (this.scancodes.length > 0)
              this.canedit = false;//保存过值的不能修改
            else {
              if (this.controlData.goods && this.controlData.goods.length > 0) {
                this.scancodes = this.controlData.goods;
                this.plus=false;
              }
            }
          });
        }else{
          this.loading = false;
        }
        this.$nextTick(() => {
          if (this.$refs.inputScan)
            this.$refs.inputScan.focus();
        })
      },
      hideDialog(haspost) {
        this.dialogFormVisible = false;
      },
      getZyanjingQRCode() {//平台自己生成的二维码
        if(!this.storegoodsbarcode) return;
        this.storegoodsbarcode=this.storegoodsbarcode.replace(/……/g,'^');
        var qrcodeLen = this.storegoodsbarcode.split('^');
        var qrcode = qrcodeLen[qrcodeLen.length - 1]
        this.storegoodsbarcode = '';
        getQRCode({storegoodsbarcode: qrcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.used == 1) {
              this.errorAlert('商品【' + qrcode + '】已出库：' + arr.outordernum + '！');
              return;
            }
            if(this.controlData.cangkucode!=arr.cangkucode) {
              this.errorAlert('商品【' + qrcode + '】所属仓库不正确！');
              return;
            }

            if(this.plus) {
              if(this.controlData.seedcode!=arr.seedcode) {
                this.errorAlert('唯一码【' + qrcode + '】所属商品不匹配！');
                return;
              }
              for (let j in this.scancodes) {
                if (this.scancodes[j].storegoodsbarcode == qrcode) {
                  this.error('重复扫码【' + qrcode + '】！')
                  return;
                }
              }
              this.scancodes.push(arr);
            }else{
              var pipei = null;
              for (let j in this.scancodes) {
                if (this.scancodes[j].storegoodsbarcode)//有编码的继续
                {
                  if (this.scancodes[j].storegoodsbarcode == qrcode) {
                    this.error('重复扫码【' + qrcode + '】！')
                    return;
                  }
                  continue;
                }

                if (pipei == null && this.scancodes[j].packagesize == arr.packagesize && this.scancodes[j].seedcode == arr.seedcode) {
                  pipei = this.scancodes[j];
                }
              }

              if (!pipei) {
                this.errorAlert('未匹配到商品！')
              } else {
                pipei.storegoodsbarcode = qrcode;
                pipei.starttime = arr.starttime;
                pipei.endtime = arr.endtime;
              }
            }
          } else {
            this.errorAlert('条码【' + qrcode + '】不存在！')
          }
        });
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';
        if (ps.M) {
          return ps.M + '/' + ps.C.replace('/', '');
        }

        return rl + 'S：' + ps.Y + '，C：' + ps.X;
      },
      error(msg, id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        if (id)
          this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      errorAlert(msg){
        this.$alert(msg, '异常', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
            this.$refs.inputScan.focus();
          }
        });
      },
      saveQRCode(erpserial) {
        if (!this.needsaveQRCode) {
          return;
        }
        updateQRouttime({
          storegoodsbarcodes: this.needsaveQRCode,
          outordernum: erpserial
        }).then(response => {
          this.needsaveQRCode = '';
        });
      },
      saveData() {
        //判断唯一码是否唯一
        if (this.scancodes.length == 0) {
            this.error('缺失扫码数据！')
            return
        }

        this.loading = true
        var codes = ''
        var arr=[]
        for (let i in this.scancodes) {
          var store = this.scancodes[i].storegoodsbarcode;

          if (store) {
            if ((';' + codes).indexOf(';' + store + ';') > -1) {
              this.error('条码【' + store + '】重复！')
              this.loading = false
              return
            }
            codes += store + ";";
            arr.push(this.scancodes[i]);
          }else{
            this.error('光度【' + this.getPackagesize(this.scancodes[i].packagesize) + '】未扫码！')
            this.loading = false
            return
          }
        }
        if (codes == '') {
          this.error('缺失条码数据！')
          this.loading = false
          return
        }
        checkBars({storegoodsbarcodes:codes}).then(response=>{//先检查唯一码是否存在
          if (response.data.code == 0) {//检查成功
            this.needsaveQRCode=codes;
            this.dialogFormVisible = false;
            this.$emit("scancodeedit", arr);
          }else{
            this.error(response.data.msg)
            this.loading=false;
          }
        });
      },
      setTimeZero(value) {
        return value > 9 ? value : '0' + value;
      },
      formatDate(date) {
        if (!date)
          return '';
        var myDate = new Date(date);
        return this.setTimeZero(myDate.getFullYear()) + '-'+(this.setTimeZero(myDate.getMonth() + 1)) + '-' + this.setTimeZero(myDate.getDate());
      }
    },
    mounted() {
    },
    components: {

    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/QRCodeScan.vue